import { Box, Button, ButtonAppearance, ButtonSize, Heading, Icon, IconSize, Spinner } from '@bechtel/gds';
import { useAppUser } from '@bechtel/ht-clients-common';
import { OperatorType, ToolRoom } from '@bechtel/ht-types';
import { get, map } from 'lodash';
import React, { useEffect, useMemo } from 'react';
import { ToolRoomDropDown } from '~/components/tool-room-dropdown';
import { useGetToolRooms, useSearchUserToolRooms } from '~/hooks';
import { HeaderStyled } from './styled';
import { CommonHeaderProps } from './types';

const CommonHeader: React.FC<CommonHeaderProps> = ({
  leftHeadering,
  selectedToolRoomId,
  onToolRoomChange,
  onClose,
  showAllToolRooms = false,
}) => {
  const { appUser } = useAppUser();
  const { getToolRoomList, data, loading } = useGetToolRooms(true);
  const { searchUserToolRooms, data: userToolRoomsData } = useSearchUserToolRooms(true);

  const toolRooms: ToolRoom[] = get(data, 'searchToolRooms.items', []);
  const userToolRoomsList: ToolRoom[] = map(get(userToolRoomsData, 'searchUserToolRooms.items', []), 'toolRoom');

  const userToolRooms = useMemo(() => {
    if (showAllToolRooms) {
      return toolRooms;
    } else {
      return userToolRoomsList && userToolRoomsList.length > 0
        ? userToolRoomsList.filter((toolRoom) => toolRoom?.adhocEnabled || toolRoom?.transferEnabled)
        : [];
    }
  }, [userToolRoomsList, showAllToolRooms, toolRooms]);

  useEffect(() => {
    getToolRoomList({
      filterInput: {
        and: [
          {
            field: 'isActive',
            operator: OperatorType.EQUAL,
            value: 'true',
          },
        ],
      },
      sortInput: [],
    });
  }, []);

  useEffect(() => {
    searchUserToolRooms({
      variables: {
        searchInput: {
          filterInput: {
            and: [
              {
                field: 'userId',
                operator: OperatorType.EQUAL,
                value: appUser?.id,
              },
            ],
          },
          sortInput: [],
        },
      },
      onCompleted: (data) => {
        if (data.searchUserToolRooms.items) {
          const toolRoomList = map(get(data, 'searchUserToolRooms.items', []), 'toolRoom');
          toolRoomList.length > 0 && onToolRoomChange(toolRoomList[0]);
        }
      },
    });
  }, [appUser?.id]);

  return (
    <HeaderStyled>
      <Box px={{ sm: '500' }}>
        <Heading color="blue.800">{leftHeadering}</Heading>
      </Box>
      {loading && showAllToolRooms ? (
        <Spinner />
      ) : (
        <ToolRoomDropDown
          toolRooms={userToolRooms}
          toolRoomId={selectedToolRoomId}
          onToolRoomChange={onToolRoomChange}
        />
      )}
      <Box p={{ sm: '400' }}>
        <Button size={ButtonSize.SMALL} onClick={onClose} appearance={ButtonAppearance.TERTIARY}>
          <Icon icon="close" fillColor="blue.800" size={IconSize.LARGE} />
        </Button>
      </Box>
    </HeaderStyled>
  );
};

export default CommonHeader;
